module.exports = __webpack_public_path__ + "static/img/KI.ad9c0353.svg";